import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen my-14 px-4 flex justify-center">
      <div className="w-full max-w-4xl">
        
        {/* Header */}
        <PageHeader>PRIVACY POLICY</PageHeader>

        {/* Card */}
           <section className="bg-white shadow-xl border border-pink-100 rounded-2xl p-6 md:p-10 mt-6">

          {/* Intro */}
          <p className="text-gray-700 leading-relaxed mb-6">
            At <span className="font-semibold text-black">Aura Girl</span>, we value your privacy and are committed to protecting your personal information. Any data you provide, including your name, contact details, or payment information, is kept strictly secure and confidential. 
            We do not sell, share, or disclose your personal information to any third parties without your consent, except where required by law. Your information is used only to improve our services, process orders, and enhance your experience on our website. 
            By using our website, you agree to our privacy practices and data protection policies.
          </p>

          <hr className="my-6 border-gray-200" />

          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              ❤ We can’t wait to see you back at AURA GIRL!
            </h2>
          </div>

        </section>
      </div>
    </main>
  );
}

